import { BaseComponent, html, nothing } from '../../lib/lit.js';
import { router } from '../../lib/router.js';
import { formatItemDate } from './community-item-list.js';

/**
 * <community-changelog> — what shipped, most recent first.
 *
 * The third dashboard region stage 1 could not fill. Credits render the handles
 * of the people whose feedback asked for the work — "Requested by" is the most
 * tempting place in the product to show a real name, and it does not.
 */
export class CommunityChangelog extends BaseComponent {
    static properties = {
        posts: { type: Array },
    };

    constructor() {
        super();
        /** @type {Array<object>} */
        this.posts = [];
    }

    _renderCredits(credits) {
        if (!credits || credits.length === 0) return nothing;

        return html`
            <div class="mt-3 pt-3 border-top">
                <div class="text-muted small mb-1">Requested by</div>
                <div class="d-flex flex-wrap gap-2">
                    ${credits.map(
                        (credit) => html`
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-secondary"
                                title=${credit.title}
                                @click=${() => router.navigate(`/items/${credit.itemId}`)}
                            >
                                ${credit.authorHandle}
                            </button>
                        `,
                    )}
                </div>
            </div>
        `;
    }

    _renderPost(post) {
        return html`
            <div class="card shadow-sm border-0 mb-3">
                <div class="card-body p-4">
                    <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                        <h3 class="h6 mb-0">${post.title}</h3>
                        ${
                            post.published
                                ? nothing
                                : html`<span class="badge text-bg-warning">Draft</span>`
                        }
                    </div>
                    <div class="text-muted small mb-3">${formatItemDate(post.publishedAt)}</div>
                    <div style="white-space: pre-wrap;">${post.body}</div>
                    ${this._renderCredits(post.credits)}
                </div>
            </div>
        `;
    }

    render() {
        if (this.posts.length === 0) return nothing;

        return html`
            <h2 class="h5 mb-3">What's shipped</h2>
            ${this.posts.map((post) => this._renderPost(post))}
        `;
    }
}

customElements.define('community-changelog', CommunityChangelog);
